import { Injectable } from '@angular/core';

@Injectable()
// tslint:disable-next-line:class-name
export class breadCrumbsService {
    constructor() {

    }
    breadCrumbs = {
        orderList: [{ linkText: '订单查询', link: '/order/list2', isEnd: true }],
        orderDetail: [{ linkText: '订单查询', link: '/order/list2' },
                    { linkText: '客户订单详情', link: '/order/detail', isEnd: true }]
    };
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/breadCrumbs.service.ts